<template>
  <div :class="d._class" :id="d.title">
    <div class="container">
      <h3>{{d.title}}</h3>
      <div style="margin: 5% 0">
        <h3 style="font-size:1.5em">Organizing Committee</h3>
        <div class="agile_team_grids">
          <div class="col-md-4 agile_team_grid" v-for="(x, i) of d.organizingCommittee" :key="i">
            <div class="view w3-agile-view" style="margin:auto">
              <img :src="x.avatar" alt=" " class="img-responsive" />
              <div class="w3lmask" style="padding-top: 80%">
                <p>{{x.brief}}</p>
              </div>
            </div>
            <h4>
              <a :href="x.homepage">{{x.name}}</a>
            </h4>
          </div>

          <div class="clearfix"></div>
        </div>
      </div>
      <div style="margin: 5% 0">
        <h3 style="font-size:1.5em">Program Committee</h3>
        <table class="table table-striped" style="margin:3em 0">
            <tbody>
                <tr v-for="(x, i) of d.programCommittee" :key="i">
                    <td>{{x.name}}</td>
                    <td>{{x.organization}}</td>
                </tr>
            </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Organization",
  props: {
    datum: {
      type: Object,
      default: function() {
        return {
          organizingCommittee: [],
          programCommittee: []
        };
      }
    }
  },
  data() {
    return {
      d: {
        _class: "team",
        title: "Organization",
        ...this.datum
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Organization.vue